import { Doughnut } from "react-chartjs-2"
import { ArcElement, Chart } from "chart.js"
import classNames from "classnames"

import styles from "./index.module.scss"

interface Props {
  values: number[]
  className?: string
  colors?: string[]
  showTooltip?: boolean
}

Chart.register(ArcElement)

export const DoughnutChart = ({ className, values, colors, showTooltip = true }: Props) => {
  const data = {
    datasets: [
      {
        data: values,
        backgroundColor: colors,
        hoverBackgroundColor: colors,
        borderWidth: 4,
        display: true,
        borderColor: "#fff",
        hoverBorderColor: "#fff",
      },
    ],
  }

  return (
    <div className={classNames(styles.rainbowWrapper, className)}>
      <Doughnut
        data={data}
        options={{
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: showTooltip,
            },
          },
          elements: {
            arc: {
              borderRadius: 10,
            },
          },
          rotation: -180,
          circumference: 360,
          cutout: "57%",
          maintainAspectRatio: true,
          responsive: true,
        }}
      />
    </div>
  )
}
